



































































import Vue from "vue";
import statusQuery from "@/common/mixins/statusQuery";
import pagination from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { ErrorEventFilterForm } from "../forms/ErrorEventFilterForm";
import { ErrorEvent } from "../models/ErrorEvent";
export default Vue.extend({
  mixins: [pagination, statusQuery, dialog],
  data() {
    const errorItems: ErrorEvent[] = [];
    return {
      errorItems,
      searchAllEvent: ""
    };
  },
  async created() {
    (this as any).getPaginationRouteQuery();
    (this as any).getStatusRouteQuery();
    await this.getErrorEvent();
  },
  watch: {
    async "$route.query"() {
      await this.getErrorEvent();
    }
  },
  methods: {
    async getErrorEvent() {
      try {
        const {
          data,
          meta
        } = await (this as any).$dep.errorEventUseCase.getAllErrorEvent(
          {
            search: this.searchAllEvent,
            id: this.$route.params.id ? this.$route.params.id : ""
          },
          {
            page: (this as any).currentPage,
            perPage: (this as any).perPage
          }
        );
        this.errorItems = data;
        (this as any).setPaginationMeta(meta);
      } catch (error) {
        (this as any).alertError("Error", error.response.data.message);
      }
    },
    async onRowClicked(errorId: number) {
      this.$router.push({
        name: "ErrorEventInformationViewPage",
        params: { id: String(errorId) }
      });
    }
  }
});
